<template>
    <div>
        <div class="px-8px py-12px px-md-10px py-md-16px">
            <v-row align="center" class="row--small">
                <v-col cols="auto">
                    <v-checkbox v-model="selected" :value="cart._id" multiple hide-details class="ma-0 px-0" />
                </v-col>
                <v-col cols="auto">
                    <div class="pr-10px">
                        <div class="border mx-auto">
                            <v-img :src="cart.product.thumb" width="120" :aspect-ratio="1/1" contain/>
                        </div>
                    </div>
                </v-col>
                <v-col>
                    <v-row no-gutters align="center">
                        <v-col cols="12" md="auto">
                            <v-row no-gutters align="center">
                                <v-col cols="12">
                                    <router-link :to="`/shop/products/${cart.product._mainProduct || cart.product._id}`">
                                        <div class="font-size-16 font-weight-medium text-truncate">{{ cart.product.name }}</div>
                                    </router-link> 
                                </v-col>
                                <v-col v-if="cart.product.type == 'option'" cols="12">
                                    <div class="font-size-14 font-size-md-16">[{{ cart.product.optionalNames.toString() }}] : {{ cart.product.optionalValues.toString() }}</div>
                                </v-col>
                                <v-col cols="12">
                                    <div class="d-inline-flex align-center font-size-18 font-size-md-24">
                                        <b class="primary--text">{{ parseInt(cart.product.salePrice * cart.quantity).format() }}</b><span class="font-size-16 ml-2px">원</span>
                                    </div>
                                    <div class="mt-6px">
                                        <v-btn v-if="cart.product._mainProduct" @click="open(cart)" x-small tile color="primary">주문수정</v-btn>
                                    </div>
                                    <!-- 주석해제시 아래 두줄 주석
                                    <div class="font-size-14 mt-2">
                                        <v-icon size="18" class="mr-1">mdi-truck-delivery</v-icon>
                                        <template v-if="cart.product.shippingPrice">배송비 {{ cart.product.shippingPrice.format() }} 원</template>
                                        <template v-else>무료배송</template>
                                    </div> -->
                                    <!-- <div class="font-size-14 mt-2">
                                        <template v-if="cart?.product?.shippingCode == 'later' && !cart?.product?.shippingPrice">착불배송</template>
                                        <template v-if="cart?.product?.shippingPrice && cart?.product?.shippingCode == 'self'">배송비 {{ cart.product.shippingPrice.format() }} 원</template>
                                        <template v-if="!cart?.product?.shippingPrice && cart?.product?.shippingCode == 'free'">무료배송</template>
                                        <template v-if="cart?.product?.shippingCode == 'order'">배송비 {{ setting?.shippingPrice?.lt.format() }} 원</template>
                                    </div> -->
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="auto">
                    <v-row class="row--x-small">
                        <v-col cols="auto">
                            <v-btn @click="decrease" outlined icon tile color="grey" width="40" height="40"><v-icon>mdi-minus</v-icon></v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-text-field v-model="cart.quantity" @input="check" outlined icon tile hide-details value="1" class="v-number-field" />
                        </v-col>
                        <v-col cols="auto">
                            <v-btn @click="increase" outlined icon tile color="grey" width="40" height="40"><v-icon>mdi-plus</v-icon></v-btn>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="auto">
                    <v-icon @click="$emit('remove', cart)">mdi-close</v-icon>
                </v-col>
            </v-row>
        </div>

        <cart-item-dialog :carts="carts" ref="cartItemDialog" @edit="(cart) => {a(cart)}"/>
    </div>
</template>

<script>
import { mdiTruckDelivery } from "@mdi/js";
import api from "@/api"
import CartItemDialog from '@/components/client/shop/cart/cart-item-dialog.vue'

export default {
    props: ["value", "cart", "carts"],
    components: {
        CartItemDialog
    },
    data(){
        return {
            mdiTruckDelivery,

            selected: this.$props.value || [],

            setting: null
        }
    },
    mounted(){
        this.init()
    },
    created(){
        this.check();
    },

    methods: {
        a(b){
            this.$emit('edit', b)
        },
        async init(){
            let { setting } = await api.v1.shop.setting.get();
            this.setting = setting;
        },
        check(){
            if(this.cart.product.stock < this.cart.quantity) this.cart.quantity = this.cart.product.stock;
            else if(this.cart.quantity < 1) this.cart.quantity = 1;
        },

        increase(){
            if(this.cart.quantity < this.cart.product.stock) this.cart.quantity++;
        },

        decrease(){
            if(1 < this.cart.quantity) this.cart.quantity--;
        },
        open(data){
            this.$refs.cartItemDialog.open(data)
        },
        close(){
            this.dialog = false
        },
        windowOpen(url){
            // window.open(`https://daehanbooks.co.kr/${url}`)
            this.$router.push(url)
            // window.open(`http://localhost:8080/${url}`)
        },
    },

    watch: {
        selected: {
            handler(value){
                this.$emit("input", value);
            },
            deep: true
        },
        value(){
            this.selected = this.value;
        },
        cart: {
            handler(value){
                this.check();
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.cart-item {
    color: #000;
}
.cart-item input {
    border: #000 1px inset; border-radius: 4px; width: 100%; max-width: 80px; height: 30px; text-align: center;
}
</style>